import { createContext, useContext } from 'react';

/**
 * LearnStockModalContext — Round 96p (Jul 4 2026).
 *
 * Any Learn guide wrapped in <LearnPage> lives inside this provider.
 * Children (e.g. the <SeeItLive> chip) call `openLearnStock(ticker, tab)`
 * to pop the Stock Modal as an OVERLAY on the current Learn page —
 * closing the modal returns the reader exactly where they left off,
 * no navigation away, no page refresh.
 *
 * This is the SEO-friendly deep-link path from static Learn content
 * into the interactive product without breaking the reading flow.
 */
export const LearnStockModalContext = createContext({
  openLearnStock: () => {},
});

export function useLearnStockModal() {
  return useContext(LearnStockModalContext);
}
